import * as React from "react";
import { Link } from "components/common";
import { Alert } from "components/bootstrap";
import DocsHelper from "util/DocsHelper";
import LicenseHelp from "license/notifications/LicenseHelp";
const LicenseTrafficViolationNotification = ({ onDismissNotification }) => /* @__PURE__ */ React.createElement(
  Alert,
  {
    bsStyle: "danger",
    className: "has-bm",
    onDismiss: () => onDismissNotification(),
    title: "Graylog License Violation Warning"
  },
  /* @__PURE__ */ React.createElement("p", null, "Your current traffic has exceeded your Graylog license traffic limitation. If traffic repeatedly exceeds the limit of the license,", " ", /* @__PURE__ */ React.createElement(Link, { to: DocsHelper.toString(DocsHelper.PAGES.LICENSE_MANAGEMENT) }, "some features will be turned off"), ".", " ", /* @__PURE__ */ React.createElement(LicenseHelp, null))
);
export default LicenseTrafficViolationNotification;
